export default "__VITE_ASSET__DpK_iVJY__"